import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import FormField from '@components/form_field';
import Checkbox from '@components/common/checkbox';
import { TDocument } from '@xeppt/xeppt-sdk/types';
import { FC } from 'react';

interface IProps {
    agreement?: TDocument;
}

const Agreement: FC<IProps> = ({ agreement }) => {
    return (
        <div className={styles.wrapper}>
            <Typography variant="body1" className={styles.description}>
                Before you complete your card order, please read and agree to the cardholder
                Agreement
            </Typography>
            <div className={styles.content_wrapper}>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                        __html: agreement?.content?.replace('{{cardholder_data}}', '') || ''
                    }}
                />
                <div className={styles.footer}>
                    <FormField<boolean>
                        name="agree"
                        renderComponent={({ value, onChange, error }) => {
                            return (
                                <>
                                    <Checkbox
                                        variant={error ? 'red' : 'dark'}
                                        checked={!!value}
                                        onClick={() => onChange(!value)}
                                    />
                                    <p>
                                        I have read, understood and agree to the cardholder
                                        Agreement above
                                    </p>
                                </>
                            );
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Agreement;
